export default "__VITE_ASSET__BcBYmk1a__"